import app from '../app.first';
import $ from 'jquery';

app.AuthModal = class extends app.Component {
    onReady($this) {
        $('.open-login-modal').click(function () {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').show();
            $('#forgot_password').hide();
            $('#auth_modal').foundation('open');
        });

        $('.open-register-candidate-modal').click(function () {
            $('#register_candidate_main').show();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').hide();
            $('#forgot_password').hide();
            $('#auth_modal').foundation('open');
        });

        $('.open-register-recruiter-modal').click(function () {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').show();
            $('#login').hide();
            $('#forgot_password').hide();
            $('#auth_modal').foundation('open');
        });
        
        $(".register-candidate-main-proceed").click(function() {
            $('#register_candidate_main').show();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').hide();
            $('#forgot_password').hide();
        });

        $(".register-candidate-email-proceed").click(function() {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').show();
            $('#register_recruiter').hide();
            $('#login').hide();
            $('#forgot_password').hide();
        });

        $(".register-recruiter-proceed").click(function() {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').show();
            $('#login').hide();
            $('#forgot_password').hide();
        });

        $(".login-candidate-proceed").click(function() {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').show();
            $('#forgot_password').hide();
        });

        $(".login-proceed").click(function() {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').show();
            $('#forgot_password').hide();
        });

        $(".forgot-password-proceed").click(function() {
            $('#register_candidate_main').hide();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').hide();
            $('#forgot_password').show();
        });

        $('#is_terms_and_condition').change(function() {
            $('#rc_terms_agree').prop('checked', $(this).prop('checked'));
        });

        $('#agree-to-terms').change(function() {
            $('#is_terms_and_condition').prop('checked', $(this).prop('checked'));
        });

        $('#rc_mobile_secondary').parent().hide();
        $('#rr_mobile_secondary').parent().hide();

        $('#rc_add_second_mobile_input').click(function() {
            $('#rc_mobile_secondary').parent().show();
            $('#rc_add_second_mobile_input').hide();
        });

        $('#rr_add_second_mobile_input').click(function() {
            $('#rr_mobile_secondary').parent().show();
            $('#rr_add_second_mobile_input').hide();
        });

        $('#fp_submit_success').hide();

        $('#fp_submit').click(function() {
            if ($('#fp_form').is(':valid')) {
                $.ajax({
                    data: $('#fp_form').serialize(),
                    url: '/forgot-password',
                    type: 'POST',
                    dataType: 'json',
                    success: function(response) {
                        console.log(response);
                        $('#fp_submit').hide();
                        $('#fp_submit_success').show();
                        setTimeout(function() {
                            $('#auth_modal').foundation('close');
                            $('#fp_submit').show();
                            $('#fp_submit_success').hide();
                        }, 5000);
                    },
                    error: function(xhr, status, error) {
                        console.log(error);
                    }
                });
            }
            else {
                $('#fp_form').submit();
            }
        });

        if ($this.data('openLogin')) {
            $('.open-login-modal').trigger('click');
        }
        if ($this.data('openCandidateReg')) {
            $('.open-register-candidate-modal').trigger('click');
        }
        if ($this.data('openRecruiterReg')) {
            $('.open-register-recruiter-modal').trigger('click');
        }
    }
}